import React, { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { SectionsFilter } from "./sections-filter/SectionsFilter";
import { SectionsTable } from "./sections-table/SectionsTable";
import { useSectionsUIContext } from "./SectionsUIContext";

export function SectionsCard({
  setReceipentIds
}) {
  // Sections Card UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      ids: sectionsUIContext.ids
    };
  }, [sectionsUIContext]);

  // Getting curret state of Sections from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type } = currentState;
    
  useEffect(() => {
    setReceipentIds(sectionsUIProps.ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionsUIProps.ids]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const title = <>Sınıf Listesi{sectionsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{sectionsUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title} />
      <CardBody>
        <SectionsFilter />
        <SectionsTable />
      </CardBody>
    </Card>
  );
}